import { lazy } from "react";

import componentLoader from "shared/utils/componentLoader";

const PresentationTopicLessonImage = lazy(() =>
  componentLoader(
    () =>
      import(
        /* webpackChunkFilename: 'PresentationTopicLessonImage', filename: 'PresentationTopicLessonImage' */
        "./components/molecules/PresentationTopicLessonImage"
      ),
  ),
);

const PresentationFeaturesSection = lazy(() =>
  componentLoader(
    () =>
      import(
        /* webpackChunkFilename: 'PresentationFeaturesSection', filename: 'PresentationFeaturesSection' */
        "./components/organisms/PresentationFeaturesSection"
      ),
  ),
);

const AboveTheFolderSection = lazy(() =>
  componentLoader(
    () =>
      import(
        /* webpackChunkFilename: 'AboveTheFolderSection', filename: 'AboveTheFolderSection' */
        "./components/organisms/AboveTheFolderSection"
      ),
  ),
);

const PresentationTextContentSection = lazy(() =>
  componentLoader(
    () =>
      import(
        /* webpackChunkFilename: 'PresentationTextContentSection', filename: 'PresentationTextContentSection' */
        "./components/organisms/PresentationTextContentSection"
      ),
  ),
);

const PresentationModulesSection = lazy(() =>
  componentLoader(
    () =>
      import(
        /* webpackChunkFilename: 'PresentationModulesSection', filename: 'PresentationModulesSection' */
        "./components/organisms/PresentationModulesSection"
      ),
  ),
);

const PresentationAditionalContentSection = lazy(() =>
  componentLoader(
    () =>
      import(
        /* webpackChunkFilename: 'PresentationAditionalContentSection', filename: 'PresentationAditionalContentSection' */
        "./components/organisms/PresentationAditionalContentSection"
      ),
  ),
);

const PresentationAvalableOffersSection = lazy(() =>
  componentLoader(
    () =>
      import(
        /* webpackChunkFilename: 'PresentationAvalableOffersSection', filename: 'PresentationAvalableOffersSection' */
        "./components/organisms/PresentationAvalableOffersSection"
      ),
  ),
);

const PresentationWarrantySection = lazy(() =>
  componentLoader(
    () =>
      import(
        /* webpackChunkFilename: 'PresentationWarrantySection', filename: 'PresentationWarrantySection' */
        "./components/organisms/PresentationWarrantySection"
      ),
  ),
);

const PresentationSafeBuySection = lazy(() =>
  componentLoader(
    () =>
      import(
        /* webpackChunkFilename: 'PresentationSafeBuySection', filename: 'PresentationSafeBuySection' */
        "./components/organisms/PresentationSafeBuySection"
      ),
  ),
);

const PresentationWhatsAppSection = lazy(() =>
  componentLoader(
    () =>
      import(
        /* webpackChunkFilename: 'PresentationWhatsAppSection', filename: 'PresentationWhatsAppSection' */
        "./components/organisms/PresentationWhatsAppSection"
      ),
  ),
);

const LexicalEditor = lazy(() =>
  componentLoader(
    () =>
      import(
        /* webpackChunkFilename: 'LexicalEditor', filename: 'LexicalEditor' */
        "@LexicalEditor/index"
      ),
  ),
);

export {
  AboveTheFolderSection,
  LexicalEditor,
  PresentationAditionalContentSection,
  PresentationAvalableOffersSection,
  PresentationFeaturesSection,
  PresentationModulesSection,
  PresentationSafeBuySection,
  PresentationTextContentSection,
  PresentationTopicLessonImage,
  PresentationWarrantySection,
  PresentationWhatsAppSection,
};
